import script from "./Accident.vue?vue&type=script&setup=true&lang=js"
export * from "./Accident.vue?vue&type=script&setup=true&lang=js"

import "./Accident.vue?vue&type=style&index=0&id=3fdc45a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdc45a6"]])

export default __exports__